{
  "home-page-title": "Webapp",
  "clear-btn": "Limpiar",
  "close-btn": "Cerrar",
  "cancel-btn": "Cancelar",
  "delete-btn": "Eliminar",
  "share-btn": "Compartir",
  "download-btn": "Descargar",
  "favorite-btn": "Favorito",
  "ok-btn": "OK",
  "done-btn": "Listo",
  "yes-btn": "Sí",
  "no-btn": "No",
  "create-story-btn": "Crear una historia",
  "submit-registration-btn": "Abrir álbum",
  "save-btn": "Guardar",
  "apply-btn": "Aplicar",
  "checkout-btn": "Pagar",
  "info-title": "Información",
  "registration-page-title": "Registrarse",
  "contact-completion-page-title": "Completar contacto",
  "registration-name-placeholder": "Tu nombre",
  "registration-email-placeholder": "Tu correo electrónico",
  "registration-email-or-phone-placeholder": "Tu correo electrónico o número de teléfono de EE. UU.",
  "registration-country-code-default": "US +1",
  "registration-accept-label": "Acepto",
  "registration-privacy-link": "Términos y condiciones",
  "registration-sms-agreement-label": "Acepto recibir mensajes de notificación de Storibox en el número de teléfono proporcionado arriba. Entiendo que recibiré mensajes SMS con actualizaciones y enlaces a mis imágenes. Pueden aplicarse tarifas de datos y mensajería. Responde STOP para cancelar.",
  "registration-submit-loading-label": "Cargando...",
  "registration-create-attendee-error-message": "No se pudo crear un asistente. Inténtalo de nuevo más tarde.",
  "registration-create-attendee-email-confirmation-error-message": "No se pudo crear un asistente. Inténtalo de nuevo más tarde. Verifica que tu correo electrónico esté confirmado.",
  "registration-invalid-us-phone-message": "Usa solo un número de teléfono de EE. UU. como este: +11234567890.",
  "registration-us-phone-length-message": "El número de teléfono debe tener 10 dígitos después del código de país (+1), pero el tuyo tiene {{length}}.",
  "registration-contact-required-message": "Se requiere correo electrónico o número de teléfono.",
  "registration-invalid-email-message": "Ingresa una dirección de correo electrónico válida.",
  "registration-email-required-message": "El correo electrónico es obligatorio.",
  "registration-sms-consent-required-message": "Se requiere tu consentimiento al acuerdo de SMS. De lo contrario, no podrás registrarte en el servicio.",
  "registration-privacy-consent-required-message": "Se requiere tu consentimiento a los Términos y condiciones. De lo contrario, no podrás registrarte en el servicio.",
  "selfies-empty-title": "¡Falta una selfie!",
  "selfies-empty-message": "Agrega una buena foto de retrato\nde todas las personas de tu grupo para encontrar\ntus imágenes rápidamente.",
  "selfies-add-btn": "+ Agregar",
  "purchase-btn": "Comprar",
  "home-select-all-btn": "Seleccionar todo",
  "home-selected-count-label_one": "1 elemento seleccionado",
  "home-selected-count-label_other": "{{count}} elementos seleccionados",
  "home-empty-album-message": "El álbum está vacío",
  "home-empty-album-subtext-message": "Todavía no hay imágenes en tu<br>álbum.",
  "home-qr-modal-title": "Mi código de álbum",
  "home-qr-modal-message": "Escanea este QR en el kiosco para acceder a tus fotos, o muéstralo a nuestros fotógrafos itinerantes cuando te lo pidan.",
  "home-qr-scanner-message": "Escanea el código QR de tus imágenes o videos desde el kiosco de visualización de fotos para vincular tu contenido multimedia con esta app.",
  "home-qr-camera-access-message": "🎥 Asegúrate de haber habilitado el acceso a la cámara para escanear el código QR.",
  "home-qr-scanner-show-my-qr-btn": "Mostrar mi QR",
  "menu-registered-selfies": "Rostros registrados",
  "menu-qr-scanner": "Escáner QR",
  "menu-album-code": "Mi código de álbum",
  "menu-privacy": "Términos y condiciones",
  "menu-faq": "FAQ",
  "menu-support": "Soporte",
  "home-step-label": "Paso {{amount}} de {{total}}",
  "home-select-up-to-images-title_one": "Selecciona hasta 1 imagen",
  "home-select-up-to-images-title_other": "Selecciona hasta {{count}} imágenes",
  "home-select-as-many-images-title": "Selecciona tantas imágenes como quieras",
  "home-select-target-label": "para \"{{name}}\"",
  "home-no-albums-found-message": "No se encontraron álbumes.",
  "home-event-config-missing-message": "Este evento no está configurado para la web app.",
  "home-create-story-waiting-message": "Tu historia se está creando. Vuelve a revisar tu álbum en unos minutos.",
  "home-ugc-tooltip-message": "¡Puedes subir fotos desde el carrete de tu cámara y mandarlas a imprimir en el kiosco!",
  "home-face-reco-tooltip-message": "Sube una selfie o una buena foto de retrato de todas las personas de tu grupo para que podamos encontrar tus imágenes.",
  "home-select-to-share-or-download-message": "Selecciona al menos una imagen para compartir o descargar.",
  "home-select-without-watermark-message": "Solo se pueden compartir o descargar imágenes sin marca de agua.",
  "home-select-to-delete-message": "Selecciona al menos una imagen para eliminar.",
  "home-share-download-locked-message": "Algunas de las fotos seleccionadas están bloqueadas. Para compartirlas o descargarlas, compra un Pase Digital.",
  "home-face-register-help-message": "Asegúrate de que tu rostro esté uniformemente iluminado y completamente visible. Mantén una expresión neutral.",
  "home-no-selfies-suggestion-message": "Ups, parece que no has registrado tu selfie. Tómate una selfie ahora para recibir tus recuerdos invaluables.",
  "home-no-face-mask-message": "SIN MASCARILLAS",
  "home-selfie-maybe-later-btn": "Tal vez después",
  "home-delete-stock-warning-message": "Has seleccionado una imagen de stock del evento para eliminar. No se puede eliminar de tu álbum y se omitirá.",
  "home-delete-confirm-message": "Eliminar imágenes de tu álbum no se puede deshacer. ¿Seguro que deseas continuar?",
  "home-delete-reason-not-wanted": "No quiero esas imágenes en mi álbum",
  "home-delete-reason-not-mine": "Esas no son mis imágenes",
  "home-delete-confirm-btn": "Sí, eliminar",
  "home-upload-unsupported-format-message": "Formato de imagen no compatible. Usa un archivo de imagen diferente.",
  "home-upload-generic-error-message": "Ocurrió un error al subir tu foto. Inténtalo de nuevo o contacta a soporte.",
  "home-upload-limit-reached-message": "Has alcanzado tu límite de carga de fotos. Contacta a soporte si necesitas subir más fotos.",
  "home-upload-processing-error-message": "Ocurrió un error al procesar tu foto. Inténtalo de nuevo o contacta a soporte.",
  "home-upload-processing-message": "Tus fotos estarán en tu álbum en un minuto.",
  "home-upload-photo-message": "Sube una foto desde el carrete de tu cámara para imprimirla.",
  "home-turn-me-into-tag-upload-message": "Tómate una selfie o sube un retrato desde el carrete de tu cámara.",
  "home-turn-me-into-tag-processing-message": "Estamos trabajando en transformar tu imagen. Actualiza esta página en un minuto aproximadamente.",
  "home-download-waiting-message": "Descargando archivos.<br/>Por favor, espera.",
  "download-selection-too-large-message": "Lo sentimos, esta selección es demasiado grande para descargarla de una sola vez. Elige menos fotos o descárgalas una por una.",
  "home-download-360-message": "Este es contenido interactivo, se ve mejor dentro de este álbum. Aun así, puedes descargar el archivo original para compartirlo en línea o verlo más tarde en apps que reconozcan el formato esférico 360.",
  "home-scanned-image-confirm-message": "¡Qué buena foto! Por seguridad, por favor confirma. ¿Es esta tu imagen?",
  "home-media-share-title": "Contenido multimedia",
  "webapp-share-title": "¡Mira mi álbum de Storibox!",
  "webapp-ogp-title": "Mi álbum de Storibox",
  "webapp-ogp-description": "Mira y comparte fotos y videos de mi álbum de Storibox.",
  "home-share-files-unsupported-message": "Tu navegador no admite compartir archivos. Usa otro navegador o descarga los archivos directamente.",
  "home-share-files-waiting-message": "Descargando archivos para compartir.<br/>Por favor, espera.",
  "title-select-a-combo": "Elige un combo",
  "title-select-a-la-carte": "A la carta",
  "title-shopping-cart": "Carrito de compras",
  "checkout-change-image-btn": "Cambiar imagen",
  "checkout-empty-cart-message": "El carrito está vacío",
  "checkout-add-product-btn": "Agregar producto",
  "checkout-subtotal-label": "Subtotal:",
  "checkout-taxes-label": "Impuestos (0%)",
  "checkout-total-label": "Importe total:",
  "checkout-promo-code-placeholder": "código promocional",
  "checkout-add-on-btn": "+ Agregar extra",
  "checkout-invalid-promo-code-message": "¡Código promocional inválido o no aplicable!",
  "checkout-discount-label": "Descuento: {{title}}",
  "checkout-delete-restriction-message": "Debes mantener al menos un paquete en tu carrito de compras si deseas comprar extras. Si necesitas cambiar el paquete, primero elimina todos los extras de tu carrito.",
  "checkout-digital-package-upsell-message": "¿Te gustaría agregar un<br>paquete digital a tu<br>carrito de compras y obtener acceso<br>a todos tus archivos digitales?",
  "photo-plus-maybe-later-btn": "Tal vez después",
  "photo-plus-upgrade-btn": "Sí, mejorar",
  "checkout-digital-package-duplicate-message": "Ya tienes un paquete de acceso digital en tu carrito de compras.<br>No se puede agregar un nuevo paquete hasta que elimines o compres el actual.",
  "title-change-image": "Seleccionar foto",
  "title-select-images": "Seleccionar fotos",
  "title-registered-selfies": "Rostros registrados",
  "title-privacy": "Términos y condiciones",
  "title-faq": "FAQ",
  "title-shoot": "Tomar foto",
  "title-remote-shoot": "Disparo remoto",
  "title-thank-you": "Gracias",
  "shoot-again-btn": "Tomar otra vez",
  "select-image-done-btn-name_final": "Listo",
  "select-image-done-btn-name_incomplete": "Siguiente",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "Tomar foto",
  "remote-shoot-start-message": "Mira a la cámara y haz clic en 'Tomar foto' cuando estés listo",
  "remote-shoot-countdown-message": "Mira las luces",
  "remote-shoot-rendering-message": "Tu contenido se está creando. Revisa tu álbum en unos segundos para ver un increíble video nuevo."
}
